import { configureStore } from "@reduxjs/toolkit";
import { userSlice } from "./features/user/userSlice";
import { mainAccountSlice } from "./features/master/main-account/mainAccountSlice";
import { subAccountSlice } from "./features/master/sub-account/subAccountSlice";
import { subGroupAccountSlice } from "./features/master/sub-group-account/subGroupAccountSlice";
import { detailAccountSlice } from "./features/master/activity/detail-account/detailAccountSlice";
import { gudangSlice } from "./features/master/gudang/gudangSlice";
import { kemasanSlice } from "./features/master/kemasan/kemasanSlice";
import { OumSlice } from "./features/master/oum/oumSlice";
import { wasteSlice } from "./features/master/waste-management/wasteSlice";
import { portServiceSlice } from "./features/master/port-service/portServiceSlice";
import { generalServiceItemSlice } from "./features/master/general-service-item/generalServiceItemSlice";

import { limbahSlice } from "./features/master/limbah/limbahSlice";
import { kelompokKegiatanSlice } from "./features/master/kelompok-kegiatan/kelompokKegiatanSlice";
import { subKegiatanSlice } from "./features/master/sub-kegiatan/subKegiatanSlice";
import { kegiatanSlice } from "./features/master/kegiatan/kegiatanSlice";
import { kendaraanSlice } from "./features/master/kendaraan/kendaraanSlice";
import { rentalUnitSlice } from "./features/master/rental-unit/rentalUnitSlice";
import { generalServiceUnitSlice } from "./features/master/general-service-unit/generalServiceUnitSlice";
import { roomSlice } from "./features/master/room/roomSlice";
import { mealsSlice } from "./features/master/meals/mealsSlice";
import { labourSlice } from "./features/master/labour/labourSlice";
import { typeOfClothingSlice } from "./features/master/type-of-clothing/typeOfClothingSlice";
import { areaRentalSlice } from "./features/master/area-rental/areaRentalSlice";
import { rentalSlice } from "./features/master/rental/rentalSlice";
import { fuelSlice } from "./features/master/fuel/fuelSlice";

import { klienSlice } from "./features/master/klien/klienSlice";
import { mpayrollSlice } from "./features/master/payroll/MPayrollSlice";
import { mpayrollSliceHO } from "./features/master/payroll-ho/MPayrollSlice";
import { CostumerSlice } from "./features/master/costumer/CostumerSlice";

import { bisnisUnitSlice } from "./features/master/bisnis-unit/bisnisUnitSlice";
import { provinsiSlice } from "./features/master/provinsi/provinsiSlice";
import { lokasiTugasSlice } from "./features/master/lokasi-tugas/lokasiTugasSlice";
import { satuanSlice } from "./features/master/satuan/satuanSlice";
import { kotaSlice } from "./features/master/kota/kotaSlice";
import { tipeKaryawanSlice } from "./features/master/tipe-karyawan/tipeKaryawanSlice";
import { golonganSlice } from "./features/master/golongan/golonganSlice";
import { bagianSlice } from "./features/master/bagian/bagianSlice";
import { bankSlice } from "./features/master/bank/bankSlice";
import { jabatanSlice } from "./features/master/jabatan/jabatanSlice";
import { jettySlice } from "./features/master/jetty/jettySlice";
import { useradminSlice } from "./features/setup/user/userSlice";
import { userOtoritasSlice } from "./features/setup/user/OtoritasSlice";
import { distentionSlice } from "./features/master/distention/distentionSlice";

import { cutiSlice } from "./features/setup/cuti/cutiSlice";
import { lemburSlice } from "./features/setup/lembur/lemburSlice";
import { jamKerjaSlice } from "./features/setup/jam-kerja/jamKerjaSlice";
import { plafonPerobatanSlice } from "./features/setup/plafon-perobatan/plafonPerobatanSlice";

import { monitoringSlice } from "./features/hrd/monitoring/monitoringSlice";
import { karyawanSlice } from "./features/hrd/karyawan/karyawanSlice";
import { timSlice } from "./features/hrd/tim/timSlice";
import { approvalSlice } from "./features/setup/approval/approvalSlice";
import { cutiTransaksiSlice } from "./features/hrd/transaksi/cuti/cutiTransaksiSlice";
import { izinTransaksiSlice } from "./features/hrd/transaksi/izin/izinTransaksiSlice";
import { perbaikanTransaksiSlice } from "./features/hrd/transaksi/perbaikan-absen/perbaikanTransaksiSlice";
import { pelatihanTransaksiSlice } from "./features/hrd/transaksi/pelatihan/pelatihanTransaksiSlice";
import { tiketTransaksiSlice } from "./features/hrd/transaksi/tiket/tiketTransaksiSlice";
import { lemburTransaksiSlice } from "./features/hrd/transaksi/lembur/lemburTransaksiSlice";
import { claimPengobatanTransaksiSlice } from "./features/hrd/transaksi/claim-pengobatan/claimPengobatanTransaksiSlice";
import { phkTransaksiSlice } from "./features/hrd/transaksi/phk/phkTransaksiSlice";
import { resignTransaksiSlice } from "./features/hrd/transaksi/resign/resignTransaksiSlice";
import { promosiTransaksiSlice } from "./features/hrd/transaksi/promosi/promosiTransaksiSlice";
import { kontrakKerjaTransaksiSlice } from "./features/hrd/transaksi/kontrak-kerja/kontrakKerjaTransaksiSlice";
import { jobRequestTransaksiSlice } from "./features/hrd/transaksi/job-request/jobRequestTransaksiSlice";
import { addJobRequestTransaksiSlice } from "./features/hrd/transaksi/job-request/AddjobRequestTransaksiSlice";

import { jobRequestOperasionalSlice } from "./features/operasional/job-request/jobRequestOperasionalSlice";
import { quatationOperasionalSlice } from "./features/operasional/quatation/quatationOperasionalSlice";
import quotationV2Reducer from "./features/operasional/quatation/quotationV2Slice";
import jrV2Reducer from "./features/operasional/job-request/jrV2Slice";
import invoiceV2Reducer from "./features/operasional/quatation/invoiceV2Slice";
import { operationalSummarySlice } from "./features/operasional/summary/OperationalSummarySlice";

import { CargoSlice } from "./features/master/cargo-carrying-unit/cargoSlice";
import { tanggalMerahSlice } from "./features/master/tanggalMerah/tanggalMerahSlice";
import { penyakitSlice } from "./features/master/penyakit/penyakitSlice";
import { sakitTransaksiSlice } from "./features/hrd/transaksi/sakit/sakitTransaksiSlice";
import { mastercutiSlice } from "./features/master/cuti/masterCutiSlice";
import { negaraSlice } from "./features/master/negara/negaraSlice";

import { jenispetugasSlice } from "./features/master/jenis-petugas/jenispetugasSlice";
import { activityequipmentSlice } from "./features/master/activity-equpment/activityequipmentSlice";
import { absensiTransaksiSlice } from "./features/hrd/transaksi/absensi/absensiTransaksiSlice";
import { jadwalKerjaSlice } from "./features/hrd/transaksi/jadwal-kerja/jadwalKerjaSlice";
import { faceEnrollmentSlice } from "./features/hrd/transaksi/face-enrollment/faceEnrollmentSlice";
import { kioskDeviceSlice } from "./features/hrd/transaksi/kiosk-device/kioskDeviceSlice";
export default configureStore({
  reducer: {
    quatationbyuser: addJobRequestTransaksiSlice.reducer,
    user: userSlice.reducer,
    mainAccount: mainAccountSlice.reducer,
    subAccount: subAccountSlice.reducer,
    subGroupAccount: subGroupAccountSlice.reducer,
    detailAccount: detailAccountSlice.reducer,
    gudang: gudangSlice.reducer,
    kemasan: kemasanSlice.reducer,
    oum: OumSlice.reducer,
    limbah: limbahSlice.reducer,
    kelompokKegiatan: kelompokKegiatanSlice.reducer,
    subKegiatan: subKegiatanSlice.reducer,
    kegiatan: kegiatanSlice.reducer,
    kendaraan: kendaraanSlice.reducer,
    rentalUnit: rentalUnitSlice.reducer,
    generalServiceUnit: generalServiceUnitSlice.reducer,
    absensiTransaksi: absensiTransaksiSlice.reducer, //tambahan
    jadwalKerja: jadwalKerjaSlice.reducer,
    faceEnrollment: faceEnrollmentSlice.reducer,
    kioskDevice: kioskDeviceSlice.reducer,
    room: roomSlice.reducer,
    meals: mealsSlice.reducer,
    mastercuti: mastercutiSlice.reducer,
    tanggalMerah: tanggalMerahSlice.reducer,
    penyakit: penyakitSlice.reducer,
    sakitTransaksi: sakitTransaksiSlice.reducer,
    rental: rentalSlice.reducer,
    labour: labourSlice.reducer,
    klien: klienSlice.reducer,
    mpayroll: mpayrollSlice.reducer,
    mpayrollho: mpayrollSliceHO.reducer,
    Costumer: CostumerSlice.reducer,
    bisnisUnit: bisnisUnitSlice.reducer,
    provinsi: provinsiSlice.reducer,
    lokasiTugas: lokasiTugasSlice.reducer,
    satuan: satuanSlice.reducer,
    kota: kotaSlice.reducer,
    tipeKaryawan: tipeKaryawanSlice.reducer,
    golongan: golonganSlice.reducer,
    bagian: bagianSlice.reducer,
    operationalSummary: operationalSummarySlice.reducer,
    bank: bankSlice.reducer,
    negara: negaraSlice.reducer,
    jenispetugas: jenispetugasSlice.reducer,
    activityequipment: activityequipmentSlice.reducer,
    jabatan: jabatanSlice.reducer,
    jetty: jettySlice.reducer,
    userAdmins: useradminSlice.reducer,
    userOtoritas: userOtoritasSlice.reducer,
    waste: wasteSlice.reducer,
    portService: portServiceSlice.reducer,
    generalServiceItem: generalServiceItemSlice.reducer,
    areaRental: areaRentalSlice.reducer,
    cargo: CargoSlice.reducer,
    distention: distentionSlice.reducer,
    cuti: cutiSlice.reducer,
    fuel: fuelSlice.reducer,
    lembur: lemburSlice.reducer,
    jamKerja: jamKerjaSlice.reducer,
    plafonPerobatan: plafonPerobatanSlice.reducer,
    typeOfClothing: typeOfClothingSlice.reducer,
    monitoring: monitoringSlice.reducer,
    karyawan: karyawanSlice.reducer,
    tim: timSlice.reducer,
    approval: approvalSlice.reducer,
    cutiTransaksi: cutiTransaksiSlice.reducer,
    izinTransaksi: izinTransaksiSlice.reducer,
    perbaikanTransaksi: perbaikanTransaksiSlice.reducer,
    pelatihanTransaksi: pelatihanTransaksiSlice.reducer,
    tiketTransaksi: tiketTransaksiSlice.reducer,
    lemburTransaksi: lemburTransaksiSlice.reducer,
    claimPengobatanTransaksi: claimPengobatanTransaksiSlice.reducer,
    phkTransaksi: phkTransaksiSlice.reducer,
    resignTransaksi: resignTransaksiSlice.reducer,
    promosiTransaksi: promosiTransaksiSlice.reducer,
    kontrakKerjaTransaksi: kontrakKerjaTransaksiSlice.reducer,
    jobRequestTransaksi: jobRequestTransaksiSlice.reducer,
    jobRequestOperasional: jobRequestOperasionalSlice.reducer,
    quatationOperasional: quatationOperasionalSlice.reducer,
    quotationV2: quotationV2Reducer,
    jrV2: jrV2Reducer,
    invoiceV2: invoiceV2Reducer,
  },
});
